 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ "exitWindow.txtTitle2" | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content style="text-align: center;">
     <div class="block-icon d-flex align-items-center justify-content-center">
        <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.1337 77.5827L20.417 71.866L43.2837 48.9993L20.417 26.1327L26.1337 20.416L49.0003 43.2827L71.867 20.416L77.5837 26.1327L54.717 48.9993L77.5837 71.866L71.867 77.5827L49.0003 54.716L26.1337 77.5827Z" fill="#D0D0D0"/>
        </svg>
     </div>
     <div class="block-name">{{ "exitWindow.txtName2" | translate }}</div>
     <div class="block-descriptions" innerHtml="{{ 'exitWindow.txtDescription' | translate }}"></div>

 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick(true)">
             <span>{{ 'buttons.txtYes' | translate }}</span>
         </button>

         <button class="btn-cancel" (click)="onNoClick()" >
             <span>{{ 'buttons.txtNo' | translate }}</span>
         </button> 
     </div>       
   </mat-dialog-actions>
